import { render } from "./SortingOfWorks.vue?vue&type=template&id=80fd93f2&scoped=true"
import script from "./SortingOfWorks.vue?vue&type=script&lang=js"
export * from "./SortingOfWorks.vue?vue&type=script&lang=js"

import "./SortingOfWorks.vue?vue&type=style&index=0&id=80fd93f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80fd93f2"]])

export default __exports__